export interface PublicBusContext {
  nasIdentifier: string;
  captiveLoginUrl: string;
  bus: { id: number; nombre: string; ruta?: string; totalAsientos: number; pisos: number };
  empresa: { nombre: string; slug: string; logoUrl?: string; colorPrimario: string; colorSecundario: string };
}

export interface RedemptionInput {
  context: string;
  codigo: string;
  authorizationCode?: string;
}

export interface CaptiveRenewal {
  context: string;
  expiresAt: string;
  renew: string;
}

export interface RedemptionResult {
  success: true;
  activationId: string;
  statusToken: string;
  status: 'PENDING' | 'ACTIVATED' | 'FAILED';
  accessExpiresAt?: string;
  redirectUrl?: string;
  plan: string;
  bus: string;
  ruta?: string;
  asiento?: number;
  crewPosition?: string;
  posibleConflicto?: boolean;
}

export class ApiError extends Error {
  constructor(public code: string, message: string, public status: number) { super(message); }
}
